/**
 * Land mask texture source: the coastline rings filled (even-odd, so lakes stay water)
 * into an 8-bit canvas. Rings clipped at the map edge are closed along that edge, which is
 * exactly where the clip happened.
 */
import type { LoadedWorld } from '@sa/mapdata';

export const LANDMASK_W = 4096;

export function buildLandMask(world: LoadedWorld): HTMLCanvasElement {
  const w = LANDMASK_W;
  const h = Math.round((w * world.height) / world.width);
  const c = document.createElement('canvas');
  c.width = w;
  c.height = h;
  const ctx = c.getContext('2d')!;
  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, w, h);
  const sx = w / world.width;
  const sy = h / world.height;
  const path = new Path2D();
  for (const ring of world.coast) {
    if (ring.length < 6) continue;
    path.moveTo(ring[0] * sx, ring[1] * sy);
    for (let i = 2; i < ring.length; i += 2) path.lineTo(ring[i] * sx, ring[i + 1] * sy);
    path.closePath();
  }
  ctx.fillStyle = '#fff';
  ctx.fill(path, 'evenodd');
  return c;
}
